import React from "react";
import {
  Popover,
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import { Download } from "@mui/icons-material";
import { useSelector } from "react-redux";

const CustomOptionsModal = ({
  isOpen,
  anchorEl,
  onClose,
  handleEdit,
  handleGetConfiguration,
  handleStationDownload
}) => {
  const userData = useSelector((state) => state.user.data.data);

  return (
    <Popover
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <Box sx={{ p: 1, maxWidth: 400 }}>
        <List>
          <ListItem button onClick={handleEdit}>
            <ListItemIcon style={{ minWidth: "30px" }}>
              <EditIcon />
            </ListItemIcon>
            <ListItemText>Edit</ListItemText>
          </ListItem>
          {handleGetConfiguration && (
            <ListItem button onClick={handleGetConfiguration}>
              <ListItemIcon>
                <CompareArrowsIcon />
              </ListItemIcon>
              <ListItemText>Get Configuration</ListItemText>
            </ListItem>
          )}
        </List>
        {(userData?.facility_admin_type === "superadmin" || userData?.facility_admin_type === "countryadmin") && (
          <List>
            <ListItem button onClick={handleStationDownload}>
              <ListItemIcon style={{ minWidth: "30px" }}>
                <Download />
              </ListItemIcon>
              <ListItemText>Download Facility Info.</ListItemText>
            </ListItem>
          </List>
        )}
      </Box>
    </Popover>
  );
};

export default CustomOptionsModal;
